export default "__VITE_ASSET__CxdpfQL9__"